import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=a35ce9a0"
import script from "./RichTextEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "quill/dist/quill.snow.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RichTextEditor.vue?vue&type=style&index=1&id=a35ce9a0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports